module.exports = __webpack_public_path__ + "img/generico-mobile.cbcfa113.png";